<div class="w-100" fxLayout="column" fxLayoutAlign="star start">
    <div class="common-info-container">
        @for (field of commonFields; track field) {
            <div class="t2 c-primary-gray-600"> {{ 'i18n_af_label_field_transaction#' + field.fieldName | translate }}</div>
            <div class="t2 c-primary-gray-900"> {{ field.fieldValue }}</div>
        }
    </div>
    <div class="divider mt-40 w-100"></div>
    @if (attachments.length) {
        <af-file-group-preview class="mt-40"
                          [attachments]="attachments"
                          [title]="'i18n_af_labelDocuments'"
                          [showDownloadAll]="true"
                          [spinnerId]="'documentsDownload_' + transaction.id"/>
        <div class="divider mt-40 w-100"></div>
    }
    <div class="container">
        <ui-kit-button class="p-absolute button-position"
                       type="secondary"
                       size="extra-small"
                       (clickListener)="toggleFields()"
                       [label]="getButtonTranslationKey() | translate"/>
        @if (senderFields?.length) {
            <af-participant-details [fields]="senderFields" label="i18n_af_labelParticipantSender"/>
        }
        <af-participant-details [fields]="receiverFields" label="i18n_af_labelParticipantReceiver"/>
    </div>
</div>
